import PropTypes from 'prop-types'
import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const Footer = ({ fluid = false, ...rest }) => (
  <footer
    className={`text-dark footer ${rest.default ? ' footer-default' : ''}`}
  >
    <br />
    <Container fluid={fluid}>
      <Row>
        <Col md={12}>
          <div className="footer-nav align-center">
            <span className="pull-right">
              &copy; {new Date().getFullYear()} California Department of Public
              Health/WIC
            </span>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
)
Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
}

export default Footer
